import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
        <span>Loading…</span>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}